import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { formatTokens } from '../../lib/formatTokens';
import { RawTokens } from '../../lib/tokenCost';

export interface AdminTokenIOChartProps {
  data: (RawTokens & { date: string })[];
  height?: number;
}

const AdminTokenIOChart: React.FC<AdminTokenIOChartProps> = ({ data, height = 300 }) => {
  const option = useMemo(() => ({
    tooltip: { trigger: 'axis' as const },
    legend: { data: ['Input Tokens', 'Cache Read', 'Cache Write', 'Output Tokens'], bottom: 0 },
    grid: { left: 60, right: 20, top: 20, bottom: 40 },
    xAxis: { type: 'category' as const, data: data.map((d) => d.date) },
    yAxis: { type: 'value' as const, axisLabel: { formatter: (v: number) => formatTokens(v) } },
    series: [
      {
        name: 'Input Tokens',
        type: 'bar',
        stack: 'tokens',
        data: data.map((d) => d.inputTokens),
        itemStyle: { color: '#6366f1' },
        barMaxWidth: 20,
      },
      {
        name: 'Cache Read',
        type: 'bar',
        stack: 'tokens',
        data: data.map((d) => d.cacheReadTokens),
        itemStyle: { color: '#f59e0b' },
        barMaxWidth: 20,
      },
      {
        name: 'Cache Write',
        type: 'bar',
        stack: 'tokens',
        data: data.map((d) => d.cacheWriteTokens),
        itemStyle: { color: '#f97316' },
        barMaxWidth: 20,
      },
      {
        name: 'Output Tokens',
        type: 'bar',
        stack: 'tokens',
        data: data.map((d) => d.outputTokens),
        itemStyle: { color: '#10b981', borderRadius: [4, 4, 0, 0] },
        barMaxWidth: 20,
      },
    ],
  }), [data]);

  return <ReactECharts option={option} style={{ height }} />;
};

export default AdminTokenIOChart;
